<template>
    <div>
        <v-container>
          <v-card style="background-color: #F5F5F5" elevation="3">
            <div class="mt-2 mb-5 text-h5 text-sm-h5 text-md-h4 text-lg-h4 ma-3 text-xl-h4 text-center">
                <span v-if="isNew">Nueva</span>
                <span v-if="!isNew">Editar</span>
                incidencia
            </div>

            <v-form
                ref="form"
                v-model="formValid"
                autocomplete="off">
            <!-- FORMULARIO INCIDENCIA -->
            <v-row class="px-7 mt-4">
                <v-col v-if="!isNew" cols="7" sm="5" md="3" lg="3" xl="2">
                    <v-text-field
                        class="mb-n7" outlined dense text
                        readonly
                        :value="inc.IncId"
                        label="Identificador">
                    </v-text-field>
                </v-col>
                <v-col cols="7" sm="5" md="3" lg="3" xl="2">
                    <v-text-field
                        class="mb-n7" outlined dense text
                        readonly
                        :value="formatDate(inc.IncTmp)"
                        label="Fecha">
                    </v-text-field>
                </v-col>
                <v-col v-if="!isNew" cols="7" sm="5" md="3" lg="3" xl="2">
                    <v-text-field
                        class="mb-n7" outlined dense text
                        readonly
                        :value="formatDate(inc.IncStaTmp)"
                        label="Fecha de estado">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row class="px-7 mt-2">
                <v-col v-if="(perIdAux == null || perIdAux === 0) && !(esEmpleado && !esDirDep)" cols="12" sm="8" md="6" lg="6" xl="4">
                    <PerFind class="mb-n7" ref="perFind" v-model="inc.Per" label="Creada por" :perCatIdAnyLevel="101"></PerFind>
                </v-col>
                <v-col v-if="!esTienda" cols="12" sm="8" md="6" lg="6" xl="4">
                    <DirFind class="mb-n7" ref="dirFind" v-model="inc.Dir" label="Tienda"></DirFind>
                </v-col>
                <!-- DATOS RESPONSABLE - INICIO -->
                <v-col v-if="esDepartamento || esDirDep" cols="12" sm="8" md="6" lg="6" xl="4">
                    <PerFind class="mb-n7" ref="perAsigFind" v-model="inc.PerAsig" label="Asignada a" :perCatIdAnyLevel="101"></PerFind>
                </v-col>
            </v-row>
            <template v-if="esDepartamento || esDirDep">
                <v-row class="px-7 mt-2">
                    <v-col class="mb-n7" cols="12" sm="5" md="3" lg="3" xl="2">
                        <DateFind clearable label="Fecha fin estimada" v-model="inc.IncTmpEst"></DateFind>
                    </v-col>
                    <v-col class="mb-n7" cols="12" sm="5" md="3" lg="3" xl="2">
                        <DateFind clearable label="Fecha comprometida entrega" v-model="inc.IncTmpComp"></DateFind>
                    </v-col>
                    <v-col cols="12" sm="5" md="3" lg="3" xl="2">
                        <v-text-field
                            outlined dense
                            hide-details
                            type="number"
                            step="0.25"
                            min="0"
                            v-model="inc.IncHorasEst"
                            label="Horas estimadas">
                        </v-text-field>
                    </v-col>
                </v-row>
            </template>
            <!-- DATOS RESPONSABLE - FIN -->
            <v-row class="px-7 mt-2">
                <v-col cols="12" sm="7" md="5" lg="5" xl="3">
                    <IncCatFind class="mb-n7" ref="incCatFind" 
                        v-model="inc.Tipo" 
                        label="Tipo" 
                        :showParentsOnly="true"
                        @change="onChangeTipo">
                    </IncCatFind>
                </v-col>
                <v-col cols="12" sm="7" md="5" lg="5" xl="3">
                    <IncCatFind class="mb-n7" ref="incCatFind"
                        v-model="inc.IncCat" 
                        label="Categoría"
                        :readonly="inc.Tipo == null || inc.Tipo.IncCatId == null"
                        :incCatIdParent="inc.Tipo != null ? inc.Tipo.IncCatId : null">
                    </IncCatFind>
                </v-col>
            </v-row>
            <v-row class="px-7 mt-2">
                <v-col cols="12" sm="5" md="4" lg="3" xl="2">
                    <PriorFind class="mb-n7" ref="priorFind" v-model="inc.Prior" label="Prioridad"></PriorFind>
                </v-col>
                <v-col  v-if="esDepartamento || esDirDep" cols="12" sm="5" md="3" lg="3" xl="2">
                    <v-text-field
                        outlined dense
                        hide-details
                        type="number"
                        min="0"
                        v-model="inc.IncPriorOrden"
                        label="Orden de prioridad"
                        @change="onChangeOrden">
                    </v-text-field>
                </v-col>
                <v-col v-if="!isNew" cols="12" sm="5" md="4" lg="3" xl="2">
                    <IncStaFind class="mb-n7" ref="incStaFind" v-model="inc.IncSta" label="Estado"></IncStaFind>
                </v-col>
            </v-row>
            <v-row class="px-7 mt-2">
                <v-col cols="12" sm="10" md="6" lg="6" xl="5">
                    <v-textarea
                        class="mt-0 mb-n7"
                        outlined
                        auto-grow
                        v-model="inc.IncDescrip"
                        required
                        :rules="[v => !!v || 'La descripción es obligatoria']"
                        label="Descripción">
                    </v-textarea>
                </v-col>
            </v-row>
            
            <v-row v-if="!isNew" class="mt-4 pl-7" no-gutters>
              <v-col cols="auto">
                <v-simple-table dense style="width: 400px; background-color: transparent; border: 1px solid grey;">
                  <template v-slot:default>
                    <tbody>
                      <tr
                        v-for="item in adjuntos"
                        :key="item.FicNom"
                      >
                        <td class="font-weight-bold">{{ item.FicNom }}</td>
                        <td class="d-flex justify-end align-center"><v-btn @click="downloadFile(item.FicNom, item.FicNomReal)" icon ><v-icon>mdi-download-circle-outline</v-icon></v-btn></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>	
			
            <v-row v-if="!isNew" class="px-7 mt-2">
                <v-col v-if="ultimaRespuesta !== ''" cols="12" sm="10" md="6" lg="6" xl="5">
                    <v-textarea
                        class="mt-0 mb-n7"
                        outlined
                        auto-grow
                        readonly
                        v-model="ultimaRespuesta"
                        label="Última respuesta">
                    </v-textarea>
                </v-col>
                <v-col cols="12" sm="10" md="6" lg="6" xl="5">
                    <v-textarea
                        class="mt-0 mb-n7"
                        outlined
                        auto-grow
                        v-model="respuesta"
                        label="Respuesta">
                    </v-textarea>
                </v-col>
            </v-row>

            <v-row v-if="!isNew" class="mx-4">
                <v-col class="mt-2" cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="dataRows"
                        :options.sync="options"
                        :footer-props="{itemsPerPageOptions: [100]}"
                        :loading="loading"
                        style="overflow: scroll"
                        mobile-breakpoint="0"
                        class="elevation-1"
                        dense>
                        <!-- eslint-disable-next-line vue/valid-v-slot -->
                        <template v-slot:item.IncHisTmp="{ item }">
                            {{ formatDate(item.IncHisTmp) }}
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>

            <v-row v-if="inc.Tipo && inc.Tipo.IncCatId === 1 && isNew" class="mt-4 ml-6" no-gutters>
              <v-col cols="auto" >
                <v-file-input
                    dense
                    hide-input
                    truncate-length="0"
                    multiple
                    @change="changeFile"
                    style="width: 40px; background-color: transparent"
                    :disabled="enviado || leyendoAdjuntos || loading"
                ></v-file-input>
              </v-col>

              <v-col v-if="isNew" cols="auto">
                <v-simple-table dense style="width: 500px; background-color: transparent">
                  <template v-slot:default>
                    <tbody>
                      <tr
                       v-for="(item, index) in adjuntos"
                        :key="index"
                      >
                        <td>{{ item.FicNom }}</td>
                        <td><v-btn @click="deleteFile(index)" icon :disabled="enviado || leyendoAdjuntos || loading"><v-icon>mdi-close</v-icon></v-btn></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>																									
			
            <!-- ACEPTAR / CANCELAR / BORRAR -->
            <v-row class="mt-2" justify="center">
                <v-btn
                    :loading="loading || leyendoAdjuntos"
                    :disabled="!isValid || loading || leyendoAdjuntos"
                    @click="onBtnSave"
                    color="primary"
                    class="mt-2 mb-4 mr-2"
                    style="width:100px">
                    Aceptar
                </v-btn>
                
                <v-btn
                    class="mt-2 mb-4 mr-2"
                    style="width:100px"
                    @click="goToList">
                    Cancelar
                </v-btn>

                <v-btn v-if="!isNew"
                    color="error"
                    class="mt-2 mb-4"
                    style="width:100px"
                    @click="onBtnShowDeleteModal()">
                    Borrar
                </v-btn>
            </v-row>
            </v-form>
          </v-card>
        </v-container>

        <!-- Modales de borrado -->
        <!-- Borrar incidencia -->
        <v-dialog
            v-model="showDeleteDialog"
            transition="dialog-bottom-transition"
            persistent
            width="500">
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    BORRAR INCIDENCIA
                </v-card-title>

                <v-card-text class="mt-2">
                    ¿Desea borrar la incidencia? Esta acción no se podrá deshacer.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                      :loading="loading"
                      color="primary"
                      @click="onBtnDelete">
                      Aceptar
                  </v-btn>
                  <v-btn @click="onBtnCancelDelete">
                      Cancelar
                  </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import DateFind from "../../components/DateFind.vue";
import DirFind from "../../components/DirFind.vue";
import IncCatFind from "../../components/IncCatFind.vue";
import IncStaFind from "../../components/IncStaFind.vue";
import PerFind from "../../components/PerFind.vue";
import PriorFind from "../../components/PriorFind.vue";
export default ({
    components: {
        DateFind, DirFind, IncCatFind, IncStaFind, PerFind, PriorFind
    },
    computed: {
        ...mapState(['empId', 'perId', 'perIdAux', 'nombreUsuario', 'nombreUsuarioAux', 'esTienda', 'esEmpleado', 'esDepartamento', 'esDirDep', 'urlRaiz'])
    },
    data () {
        return {
            loading: false,
            isNew: true,
            isValid: false,
            formValid: false,
            showDeleteDialog: false,
            inc: {
                IncId: 0,
                IncTmp: null,
                Dir: {},
                Per: {},
                Prior: {},
                IncSta: {},
                Tipo: null,
                IncCat: {},
                IncDescrip: '',
                IncRespuesta: '',
                IncHis: [],
                PerAsig: {},
                IncTmpEst: null,
                IncTmpComp: null,
                IncHorasEst: null,
                IncPriorOrden: null
            },
            respuesta: '',
            ultimaRespuesta: '',
            // IncHis table
            dataRows: [],
            options: {itemsPerPage: 100},
            headers: [
                { text: 'Fecha', width:145, sortable: false, value: 'IncHisTmp' },
                { text: 'Persona', width:225, sortable: false, value: 'Per.PerNom' },
                { text: 'Categoría', width:200, sortable: false, value: 'IncCat.IncCatNom' },
                { text: 'Estado', width:112, sortable: false, value: 'IncSta.IncStaNom' },
                { text: 'Respuesta', width:275, sortable: false, value: 'IncHisRespuesta' }
            ],
            adjuntos: [],
            enviado: false,
            leyendoAdjuntos: false,
        }
    },
    watch: {
      inc: {
        handler () {
            this.isValid = this.validate(false);
        },
        deep: true,
      }
    },
    mounted() {
      this.isNew = this.$route.meta.isNew;
      
      // Dir Init.
      const dir = this.$store.state.dir;
      if(dir != null && dir.DirId != null && dir.DirId != 0) {
        this.inc.DirId = dir.DirId;
        this.inc.Dir = {
          DirId: dir.DirId,
          DirNom: dir.DirNom
        }
      }

      if(!this.isNew) {
        this.inc.IncId = this.$route.params.id;
        this.loadData();
      } else {
        this.inc.IncTmp = new Date();
        // Per init.
        if (this.esEmpleado)
        {
          if(!this.esDirDep)
          {
            this.inc.PerId = this.perId;
            this.inc.Per = {
                PerId: this.perId,
                PerNom: this.nombreUsuario
            }
          }
        }
        else if(this.perIdAux != null && this.perIdAux != 0) {
          this.inc.PerId = this.perIdAux;
          this.inc.Per = {
              PerId: this.perIdAux,
              PerNom: this.nombreUsuarioAux
          }
        }
      }
    },
    methods: {
      goToList() {
        this.$router.push('/incidencias');
      },

      //#region Llamadas a la API
      getDataFromApi() {
        this.loading = true;
        return new Promise((resolve) => {
          const controllerParameters = {
            Action: 'GET_INC',
            IncId: this.inc.IncId,
            DirId: this.inc.DirId
          };
          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/inc", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const item = result.data.Inc;

            setTimeout(() => {
                this.loading = false;
                resolve({
                    item
                })
            }, 1000)
          })
          .catch(error => {
            if(error != null) {
                this.loading = false;
                alert('Error al cargar la incidencia.');
                this.goToList();
            }
          });
        })
      },
      postDataToApi() {
        this.loading = true;

        // Asignamos los IDs de los objetos hijos
        this.inc.DirId = this.inc.Dir != null ? this.inc.Dir.DirId : null;
        this.inc.PerId = this.inc.Per != null ? this.inc.Per.PerId : null;
        this.inc.PerIdAsig = this.inc.PerAsig != null ? this.inc.PerAsig.PerId : null;
        this.inc.IncCatId = this.inc.IncCat != null ? this.inc.IncCat.IncCatId : null;
        this.inc.PriorId = this.inc.Prior != null ? this.inc.Prior.PriorId : null;
        this.inc.IncStaId = this.inc.IncSta != null ? this.inc.IncSta.IncStaId : null;
        this.inc.IncHis = [];

        let incHisPerId = 0;
        if (this.esEmpleado || this.perIdAux == null || this.perIdAux === 0)
        {
            incHisPerId = this.perId;
        }
        else 
        {
            incHisPerId = this.perIdAux;
        }
        this.inc.IncRespuesta = this.respuesta;


        return new Promise((resolve) => {
          const controllerParameters = {
            Action: 'SAVE_ENTITY',
            Inc: this.inc,
            EmpId: this.empId,
            IncHisPerId: incHisPerId,
            Desarrollo: this.$store.state.desarrollo,
            Adjuntos: this.adjuntos.map(adj => ({
              FicNom: adj.FicNom,
              FicNomReal: adj.FicNomReal || null,
              Base64: adj.Base64 || null
            }))
          };
          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/inc", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const item = result.data;

            setTimeout(() => {
                this.loading = false;
                resolve({
                    item
                })
            }, 1000)
          })
          .catch(() => {
            this.loading = false;

            resolve({
              item: {
                Success: false,
                Message: 'No se pudo confirmar el guardado. Comprueba el listado antes de volver a intentarlo.'
              }
            });
          });
        })
      },
      deleteDataFromApi() {
        this.loading = true;
        return new Promise((resolve) => {
          const controllerParameters = {
            Action: 'DEL_ENTITY',
            IncId: this.inc.IncId,
            EmpId: this.empId,
            Desarrollo: this.$store.state.desarrollo
          };
          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/inc", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const item = result.data;

            setTimeout(() => {
                this.loading = false;
                resolve({
                    item
                })
            }, 1000)
          })
          .catch(error => {
            if(error != null) {
                this.loading = false;
                alert('Error al borrar la incidencia.');
            }
          });
        })
      },
      //#endregion

      //#region Carga de datos
      loadData() {
        this.getDataFromApi()
          .then(data => {
            if(data.item == null) {
              alert('Incidencia no encontrada.');
              this.goToList();
              return;
            }

            this.adjuntos = data.item.IncFic || [];           							   
            // Init. dates
            if(data.item.IncTmpEst != null)
            {
              const dateEst = new Date(data.item.IncTmpEst);
              const dateStringEst = dateEst.getFullYear() + '-' + 
              String(dateEst.getMonth() + 1).padStart(2, '0') + '-' +
              String(dateEst.getDate()).padStart(2, '0');
              data.item.IncTmpEst = dateStringEst;
            }

            if(data.item.IncTmpComp != null)
            {
              const dateComp = new Date(data.item.IncTmpComp);
              const dateStringComp = dateComp.getFullYear() + '-' + 
              String(dateComp.getMonth() + 1).padStart(2, '0') + '-' +
              String(dateComp.getDate()).padStart(2, '0');
              data.item.IncTmpComp = dateStringComp;
            }

            this.inc = data.item;

            // Init. tipo
            if(this.inc.IncCat != null && this.inc.IncCat.IncCatParent != null) {
              this.inc.Tipo = this.inc.IncCat.IncCatParent;
            }
        
            this.dataRows = this.inc.IncHis; // Historico de incidencias
            this.ultimaRespuesta = this.inc.IncRespuesta;
          });
      },
      //#endregion

      //#region Click guardado
      onBtnSave() {
        if (this.leyendoAdjuntos || this.loading) {
          return;
        }

        this.isValid = this.validate();

        if (!this.isValid) {
          return;
        }

        this.postDataToApi().then(data => {
          if (data.item.Success) {
            if (data.item.Warning) {
              alert(data.item.Warning);
            }

            this.goToList();
          } else {
            alert(data.item.Message || 'Error al guardar la incidencia.');
          }
        });
      },
      //#endregion

      //#region Click borrar
      onBtnDelete() {
        this.deleteDataFromApi().then(data => {
          if (data.item.Success) {
            this.showDeleteDialog = false;
            this.goToList();
          }
          else {
            alert(data.item.Message);
          }
        });
      },
      //#endregion

      //#region Gestión de modales
      onBtnShowDeleteModal() {
        this.showDeleteDialog = true;
      },
      onBtnCancelDelete() {
        this.showDeleteDialog = false;
      },
      //#endregion

      //#region Validar formulario
      validate(validateForm = true) {
          if (validateForm) {
            this.$refs.form.validate();
          }
          if (this.inc == null) { return false; }
          if (this.inc.Dir == null || this.inc.Dir.DirId == null) { return false; }
          if (this.inc.Per == null || this.inc.Per.PerId == null) { return false; }
          if (this.inc.IncCat == null || this.inc.IncCat.IncCatId == null) { return false; }
          if (this.inc.Prior == null || this.inc.Prior.PriorId == null) { return false; }
          if (this.inc.IncDescrip == null || this.inc.IncDescrip == '') { return false; }
          return true;
      },
      //#endregion
      onChangeTipo() {
          this.inc.IncCat = null; 
          this.$forceUpdate();
      },
      onChangeOrden() {
        if (this.inc.IncPriorOrden == null || this.inc.IncPriorOrden === '') { return; }
        this.inc.IncPriorOrden = Math.trunc(this.inc.IncPriorOrden);
      },
      formatDate (value) {
        if(value == null) { return ''; }
        const date = new Date(value);
        return String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0')  + '/' + date.getFullYear() + 
            ' ' + String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0');
      },
      // AÑADIR FUNCIONES CHANGE/DELETE
      // changeFile: function(fileArray) {
      //   var itemKey = 0;
      //   fileArray.forEach(element0 => {
      //     itemKey--;

      //     let frmData = new FormData();
      //     frmData.append('file', element0);

      //     var raizUrl = this.urlRaiz;

      //     var AuthToken = localStorage.getItem('token');
      //     axios({ method: "POST", "url": raizUrl + "/api/file", "data": frmData, "headers": {"content-type": "multipart/form-data", "Authorization": AuthToken }}).then(result => {
      //       if (result.status >= 200 && result.status <= 299) {
      //         var objFic = {IncFicId: itemKey, IncId: this.inc.IncId, FicNom: element0.name, FicNomReal: result.data};
      //         this.adjuntos.push(objFic);
      //       }
      //       else {
      //         alert(result.statusText);
      //       }
      //     });
      //   });
      // },

      leerArchivoBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();

          reader.onload = () => {
            resolve({
              FicNom: file.name,
              FicNomReal: null,
              Base64: reader.result
            });
          };

          reader.onerror = () => {
            reject(new Error('No se pudo leer el archivo: ' + file.name));
          };

          reader.onabort = () => {
            reject(new Error('Se canceló la lectura: ' + file.name));
          };

          reader.readAsDataURL(file);
        });
      },

      async changeFile(fileArray) {
        if (this.leyendoAdjuntos || this.loading || this.enviado) {
          return;
        }

        const archivos = Array.from(fileArray || []);

        if (archivos.length === 0) {
          return;
        }

        this.leyendoAdjuntos = true;

        try {
          const nuevosAdjuntos = await Promise.all(
            archivos.map(file => this.leerArchivoBase64(file))
          );

          this.adjuntos.push(...nuevosAdjuntos);
        } catch (error) {
          alert(error.message || 'Error al leer los archivos.');
        } finally {
          this.leyendoAdjuntos = false;
        }
      },
      deleteFile(index) {
        if (this.enviado || this.leyendoAdjuntos || this.loading) {
          return;
        }

        this.adjuntos.splice(index, 1);
      },
      async downloadFile(AdjuntoFicNom, AdjuntoFicNomReal) {
        try {
          const result = await axios({
            method: 'POST',
            url: this.urlRaiz + '/api/inc',
            data: {
              Action: 'DOWNLOAD_FIC',
              IncId: this.inc.IncId,
              FicNomReal: AdjuntoFicNomReal
            },
            headers: {
              'content-type': 'application/json',
              Authorization: localStorage.getItem('token')
            }
          });

          if (!result.data || !result.data.Base64) {
            throw new Error('El servidor no ha devuelto el archivo.');
          }

          const binario = atob(result.data.Base64);
          const bytes = new Uint8Array(binario.length);

          for (let i = 0; i < binario.length; i++) {
            bytes[i] = binario.charCodeAt(i);
          }

          const blob = new Blob([bytes], {
            type: 'application/octet-stream'
          });

          const url = URL.createObjectURL(blob);
          const enlace = document.createElement('a');

          enlace.href = url;
          enlace.download = result.data.FicNom || AdjuntoFicNom;
          enlace.style.display = 'none';

          document.body.appendChild(enlace);
          enlace.click();
          enlace.remove();

          setTimeout(() => URL.revokeObjectURL(url), 1000);
        } catch (error) {
          alert('No se ha podido descargar el archivo.');
        }
      },
		
    } 
})
</script>
